module.exports = __webpack_public_path__ + "static/media/fold_arrow.d72cd2bf.svg";